var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B3BFD3",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 13.8278C11.6665 13.3706 12.0459 13 12.493 13H27.5067C27.9632 13 28.3332 13.3708 28.3332 13.8278V27.1722C28.3332 27.6293 27.9538 28 27.5067 28H12.493C12.0365 28 11.6665 27.6292 11.6665 27.1722V13.8278ZM16.6665 14.6667V26.3333H23.3332V14.6667H16.6665ZM13.3332 14.6667V16.3333H14.9998V14.6667H13.3332ZM24.9998 14.6667V16.3333H26.6665V14.6667H24.9998ZM13.3332 18V19.6667H14.9998V18H13.3332ZM24.9998 18V19.6667H26.6665V18H24.9998ZM13.3332 21.3333V23H14.9998V21.3333H13.3332ZM24.9998 21.3333V23H26.6665V21.3333H24.9998ZM13.3332 24.6667V26.3333H14.9998V24.6667H13.3332ZM24.9998 24.6667V26.3333H26.6665V24.6667H24.9998Z",
    fill: "#202024"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/Type.49dd075bfa069834c5f48c7be427fa15.svg";
export { ForwardRef as ReactComponent };